import { Slider, Text } from "@mantine/core"
import type { TQuestionProps } from "./types"
import { useScaleValue } from "./utils"

const marks = [0, 25, 50, 75, 100]

export function QuestionPercent({ question, value, setValue }: TQuestionProps) {
  const { color, value: parsedValue, process } = useScaleValue(question, value)
  return (
    <Slider
      min={0}
      mih={60}
      size="xl"
      label={null}
      color={color}
      value={parsedValue}
      thumbSize={30}
      thumbChildren={
        <Text fz="sm" fw={500}>
          {parsedValue}
        </Text>
      }
      max={marks[marks.length - 1]}
      onChange={(value) => setValue(process(value))}
    />
  )
}
